/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';

import Icon from '../Icon';
import Text from '../Text';

export type SortOrder = 'asc' | 'desc';

type Props = {
  children?: React.ReactNode;
  style?: StyleSet;
  sortOrder?: SortOrder;
  onPress?: () => void;
};

function DataTableHeaderCell({ children, style, sortOrder, onPress }: Props) {
  return (
    <TouchableOpacity
      activeOpacity={0.6}
      style={[styles.root, style]}
      onPress={onPress}
      disabled={!onPress}
    >
      <Text type="label" numberOfLines={1} style={styles.headerText}>
        {children}
      </Text>
      {sortOrder && (
        <Icon
          name="arrowDown"
          size="S"
          style={sortOrder === 'asc' && styles.arrowUp}
        />
      )}
    </TouchableOpacity>
  );
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontWeight: '600',
  },
  arrowUp: {
    transform: 'rotate(0.5turn)' as any,
  },
});

export default DataTableHeaderCell;
